import {
    EDUCATOR_PAGE_GET_REQUEST,
    EDUCATOR_CACHED_EDUCATOR_DATA_USED,
    EDUCATOR_PAGE_GET_SUCCESS,
    EDUCATOR_PAGE_GET_FAILURE,
} from '../actions/types';

export const initialState = {
    currentEducator: {
        name: '',
        slug: '',
        bio: '',
        covid: '',
        logo_url: '',
        cover_url: '',
        links: {
            web: '',
            instagram: '',
            twitter: '',
            facebook: '',
            linkedin: '',
            pinterest: '',
            youtube: '',
        },
        location: {
            city: '',
        },
    },
    currentCourses: [],
    loading: true,
};

export default function educator(state = initialState, action) {
    switch (action.type) {
        case EDUCATOR_PAGE_GET_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case EDUCATOR_PAGE_GET_SUCCESS:
            return {
                ...state,
                currentEducator: { ...state.currentEducator, ...action.payload.currentEducator },
                loading: false,
            };
        case EDUCATOR_PAGE_GET_FAILURE:
        case EDUCATOR_CACHED_EDUCATOR_DATA_USED:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}
